import React, { Component } from 'react';
import './ImageCarousel.css';
import DynamicImageFitCriteria from '../images/DynamicImageFitCriteria';
import DynamicImage from '../images/DynamicImage';
import FitType from '../images/FitType';
import UrlHelper from '../core/UrlHelper';
import ParameterErrors from '../errors/ParameterErrors';
import { faExpand} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
const {throwNotProvided}=ParameterErrors;
export default class ImageCarousel extends Component {
	constructor(props){
		super(props)
		const {className, images, aspectRatioThreshold, getContainerViewPort, onExpandImage, rootUrl}=props;
		this._rootUrl = rootUrl?UrlHelper.makeSureSlashOnEnd(rootUrl):null;
		this._className = className;
		this._callbackExpandImage = onExpandImage;
		if(getContainerViewPort===undefined||getContainerViewPort===null)throwNotProvided('getContainerViewPort');
		this._getContainerViewPort = getContainerViewPort;
		this._getContainerAspectRatio = this._getContainerAspectRatio.bind(this);
		this._getVerticalElseHorizontal = this._getVerticalElseHorizontal.bind(this);
		this.calculateAndUpdateVerticalOrHorizontal = this.calculateAndUpdateVerticalOrHorizontal.bind(this);
		this._handleClickExpand= this._handleClickExpand.bind(this);
		this._createImageElements= this._createImageElements.bind(this);
		this._element = React.createRef();
		this._dynamicImageFitCriteriaVertical = new DynamicImageFitCriteria({fitType:FitType.WIDTH});
		this._dynamicImageFitCriteriaHorizontal = new DynamicImageFitCriteria({fitType:FitType.HEIGHT});
		this.state ={imageElements:[], verticalElseHorizontal:false};
	}
	componentDidUpdate(previousProps){
		const imagesChanged = previousProps.images!==this.props.images;
		const rootUrlChanged = previousProps.rootUrl!==this.props.rootUrl;
		if(imagesChanged){
			this._images = this.props.images;
		}
		if(rootUrlChanged){
			const rootUrl = this.props.rootUrl;
			this._rootUrl = rootUrl?UrlHelper.makeSureSlashOnEnd(rootUrl):null;
		}
		if(imagesChanged||rootUrlChanged){
			this.calculateAndUpdateVerticalOrHorizontal();
			this._createImageElements();
		}
	}
	componentDidMount(){
		this.calculateAndUpdateVerticalOrHorizontal();
	}
	calculateAndUpdateVerticalOrHorizontal(){
		const verticalElseHorizontal = this._getVerticalElseHorizontal();
		if(this.state.verticalElseHorizontal===verticalElseHorizontal)return;
		this.setState({verticalElseHorizontal:verticalElseHorizontal});
	}
	_createImageElements(){
		if(!this._images){
			this.setState({imageElements:[]});
			return;
		}
		const verticalElseHorizontal = this._getVerticalElseHorizontal();
		const imageElements = [];
		this._images.forEach((image)=>{
			let relativeUrl;
			if(image instanceof DynamicImage){
				const viewPort = this._getContainerViewPort();
				const dynamicImageEntry = image.getBestEntryToFit(verticalElseHorizontal
				?{fitCriteria:this._dynamicImageFitCriteriaVertical, width:viewPort[0]}
				:{fitCriteria:this._dynamicImageFitCriteriaHorizontal, height:viewPort[1]});
				if(dynamicImageEntry===undefined||dynamicImageEntry===null)
					throw new Error('No dynamicImageEntry was returned');
				relativeUrl = dynamicImageEntry.relativePath;
			}
			else {
				if(typeof(image )!=='string')
					throw new Error('Not implemented');
				relativeUrl = image;
			}
			const url = (this._rootUrl===null?'':this._rootUrl)+UrlHelper.removeStartSlash(relativeUrl);
			imageElements.push((<div className="image-wrapper" ><img src={url}></img><FontAwesomeIcon className="expand" icon={faExpand} onClick={()=>{
				this._handleClickExpand(image);
			}}/></div>))
		});
		this.setState({imageElements:imageElements});
	}
	_getContainerAspectRatio(){
		const containerViewPortDimensions = this._getContainerViewPort();
		 let aspectRatio =  containerViewPortDimensions[0]/containerViewPortDimensions[1];
		 if(isNaN(aspectRatio))return 1;
		 return aspectRatio;
	}
	_getVerticalElseHorizontal(){		
		const containerAspectRatio = this._getContainerAspectRatio();
		const verticalElseHorizontal = this._aspectRatioThreshold>containerAspectRatio;
		return verticalElseHorizontal;
	}
	_handleClickExpand(image){
		let largestImageUrl;
		if(image instanceof DynamicImage){
			largestImageUrl = image.getLargestEntry().relativePath;
		}
		else{
			if(typeof(image)!=='string'){
				throw new Error(`Not implemented for type ${typeof(image)}`);
			}
			largestImageUrl = image;
		}
		this._callbackExpandImage({image:largestImageUrl, rootUrl:this._rootUrl});
	}
	render() {
		let className = 'image-carousel';
		if(this._className)
			className+=` ${this._className}`;
		className+=this.state.verticalElseHorizontal?' vertical':' horizontal';
		return (<div className={className} ref={this._element}>
								<div className="inner">
				{this.state.imageElements}
				</div>
			</div>)
	}
}
